import React from "react";
import DonationBanner from "../../images/donation-banner.png";
import PacQR from "../../images/pac-qr.png";
import PacLogo from "../../images/PACQR.png";

import NonProfitQR from "../../images/nonprofit-qr.png";
import NonProfitLogo from "../../images/NPOQR.png";

import DacQR from "../../images/dac-qr.png";
import DacLogo from "../../images/DACQR.png";

import FOGQR from "../../images/logo3.png";
import FOGLogo from "../../images/FOGQR.png"

export default function TempleRakshak() {
  return (
    <>
      <style>{`
        *{
          margin:0;
          padding:0;
          box-sizing:border-box;
        }

        body{
          font-family:"Poppins",sans-serif;
          background:#f3ead7;
        }

        .temple-page{
          width:100%;
          min-height:100vh;
          background:linear-gradient(to right,#ffdb5e 0%,#ffffff 100%);
          color:#222;
          padding:80px 0;
        }

        .container{
          width:92%;
          max-width:1200px;
          margin:auto;
        }

        .main-title{
          text-align:center;
          margin-bottom:60px;
        }

        .main-title h1{
          font-size:48px;
          font-weight:900;
          color:#000;
          margin-bottom:20px;
          line-height:1.1;
        }

        .section-divider{
          width:100%;
          max-width:900px;
          margin:32px auto 50px;
          display:flex;
          align-items:center;
          justify-content:center;
          gap:18px;
        }

        .section-divider::before,
        .section-divider::after{
          content:"";
          flex:1;
          height:3px;
          background:linear-gradient(
            to right,
            transparent,
            #1a2a5a,
            #d4af37,
            transparent
          );
          border-radius:10px;
          box-shadow:0 2px 6px rgba(0,0,0,.18);
        }

        .section-divider span{
          font-size:26px;
          color:#1a2a5a;
          text-shadow:0 2px 6px rgba(0,0,0,.15);
        }

        /* Donation Sections */

        .donation-section{
  margin:50px auto;
  text-align:center;
  max-width:1100px;
}

.donation-section h2{
  font-size:32px;
  font-weight:800;
  color:#8b5a00;
  line-height:1.4;
  margin-bottom:18px;
}

.donation-section p{
  font-size:24px;
  font-weight:800;
  color:#222;
  line-height:1.6;
}
.logo-row{
  display:flex;
  justify-content:center;
  gap:70px;
  margin-top:35px;
  flex-wrap:wrap;
}

.logo-card{
  display:flex;
  flex-direction:column;
  align-items:center;
}

.logo-placeholder{
  width:260px;
  height:260px;
  display:flex;
  align-items:center;
  justify-content:center;
}

.logo-placeholder img{
  width:100%;
  height:100%;
  object-fit:contain;
}

.donate-btn{
  margin-top:20px;
  padding:16px 42px;
  font-size:22px;
  font-weight:800;
  color:#fff;
  border:none;
  border-radius:14px;
  cursor:pointer;
  text-transform:uppercase;

  background:linear-gradient(180deg,#ffcc4d,#c58b2a);

  box-shadow:
      0 8px 0 #8b5a00,
      0 12px 20px rgba(0,0,0,.25);

  transition:.2s;
}

.donate-btn:hover{
  transform:translateY(-3px);
}

.donate-btn:active{
  transform:translateY(5px);
  box-shadow:
      0 3px 0 #8b5a00,
      0 6px 12px rgba(0,0,0,.25);
}
.qr-border{
  padding:14px;
  background:#fff;
  border:5px solid #d4af37;
  border-radius:22px;

  box-shadow:
    0 0 0 3px #8b5a00,
    0 12px 30px rgba(0,0,0,.18);

  transition:0.35s ease;
}

.qr-border:hover{
  transform:translateY(-5px) scale(1.03);
  box-shadow:
    0 0 0 3px #8b5a00,
    0 18px 40px rgba(0,0,0,.28);
}
.banner-container{
  display:flex;
  justify-content:center;
  margin:25px 0 70px;
}

.banner-image{
  width:100%;
  max-width:950px;
  border-radius:22px;

  border:5px solid #143b8f;

  box-shadow:
      0 0 0 5px #d4af37,
      0 18px 45px rgba(0,0,0,.28);

  transition:.35s ease;
}

.banner-image:hover{
  transform:translateY(-6px) scale(1.01);

  box-shadow:
      0 0 0 5px #d4af37,
      0 25px 55px rgba(0,0,0,.35);
}
.donation-subheading {
  text-align: center;
  margin-top: -25px;
  margin-bottom: 35px;
}

.donation-subheading h3 {
  font-size: 26px;
  font-weight: 800;
  color: #8b5a00;
  margin: 8px 0;
  line-height: 1.3;
}
        @media (max-width:768px){

          .temple-page{
            padding:40px 0;
          }

          .container{
            width:95%;
          }

          .main-title{
            margin-bottom:30px;
          }

          .main-title h1{
            font-size:24px;
            margin-bottom:12px;
          }

          .section-divider{
            margin:16px auto 30px;
            gap:10px;
          }

          .section-divider span{
            font-size:16px;
          }

          .section-divider::before,
          .section-divider::after{
            height:2px;
          }

           .donation-section{
    margin:30px auto;
  }

  .donation-section h2{
    font-size:18px;
    line-height:1.4;
    margin-bottom:10px;
  }

  .donation-section p{
    font-size:12px;
    line-height:1.5;
  }
 .logo-row{
    gap:30px;
  }

  .logo-placeholder{
  width:170px;
  height:170px;
}

  .donate-btn{
    width:130px;
    font-size:16px;
    padding:12px 0;
  }
 .qr-border{
    padding:10px;
    border-width:4px;
    border-radius:16px;
  }
 .banner-container{
    margin:15px 0 40px;
  }

  .banner-image{
    border-width:3px;
    border-radius:16px;
  }
   .donation-subheading {
    margin-top: -15px;
    margin-bottom: 25px;
  }

  .donation-subheading h3 {
    font-size: 18px;
    margin: 5px 0;
  }
        }
      `}</style>

      <div className="temple-page">
        <div className="container">

          <div className="main-title">
            <h1>DONATIONS</h1>
            
            <div className="section-divider">
              <span>✦ ✦ ✦</span>
            </div>
            <div className="donation-subheading">
    <h3>Donate and become our Member</h3>
    <h3>Support the Mission</h3>
  </div>
          </div>
            <div className="banner-container">
  <img
    src={DonationBanner}
    alt="Donation Banner"
    className="banner-image"
  />
</div>
          {/* Section 1 */}
          <div className="donation-section">
            <h2>
              To support Americans4Hindus Political Action Committee (A4H PAC)
            </h2>

            <p>
              Scan the QR code or click the button below to donate and become
              our member.
            </p>
            <div className="logo-row">

  <div className="logo-card">
  <div className="logo-placeholder qr-border">
    <img src={PacQR} alt="PAC QR Code" />
  </div>
</div>

<div className="logo-card">
  <div className="logo-placeholder">
    <img src={PacLogo} alt="PAC Logo" />
  </div>

  <a
    href="https://secure.anedot.com/a4h/donate"
    target="_blank"
    rel="noopener noreferrer"
    className="donate-btn"
    style={{
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "center",
      textDecoration: "none",
    }}
  >
    Donate
  </a>
</div>

</div>
          </div>

          {/* Section 2 */}
          <div className="donation-section">
            <h2>
              To support Americans4Hindus Non Profit Organization 501(C)(3)
            </h2>

            <p>
              Scan the QR code or click the button below to donate and become
              our member.
            </p>
            <div className="logo-row">

  <div className="logo-card">
  <div className="logo-placeholder qr-border">
    <img src={NonProfitQR} alt="Non Profit QR Code" />
  </div>
</div>

<div className="logo-card">
  <div className="logo-placeholder">
    <img src={NonProfitLogo} alt="Non Profit Logo" />
  </div>

  <a
    href="https://givebutter.com/DONATEA4HNPO"
    target="_blank"
    rel="noopener noreferrer"
    className="donate-btn"
    style={{
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "center",
      textDecoration: "none",
    }}
  >
    Donate
  </a>
</div>

</div>
          </div>

          {/* Section 3 */}
          <div className="donation-section">
            <h2>
              To support Americans4Hindus Dharma Action Council 501(C)(4)
            </h2>

            <p>
              Americans4Hindus Dharma Action Council
Is in the process of securing status as a 501(c)(4) organization. Tax ID #41-5306681.
            </p>
            <div className="logo-row">

  <div className="logo-card">
  <div className="logo-placeholder qr-border">
    <img src={DacQR} alt="DAC QR Code" />
  </div>
</div>

<div className="logo-card">
  <div className="logo-placeholder">
    <img src={DacLogo} alt="DAC Logo" />
  </div>

  <a
    href=""
    target="_blank"
    rel="noopener noreferrer"
    className="donate-btn"
    style={{
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "center",
      textDecoration: "none",
    }}
  >
    Donate
  </a>
</div>

</div>

          </div>
{/* Section 1 */}
          <div className="donation-section">
            <h2>
              To support Festival of Globe Non Profit Organization 501(C)(3)
            </h2>

            <p>
              Scan the QR code or click the button below to donate and become
              our member.
            </p>
            <div className="logo-row">

  <div className="logo-card">
  <div className="logo-placeholder qr-border">
    <img src={FOGQR} alt="FOG QR Code" />
  </div>
</div>

<div className="logo-card">
  <div className="logo-placeholder">
    <img src={FOGLogo} alt="FOG Logo" />
  </div>

  <a
    href="https://givebutter.com/Nnf9Vr"
    target="_blank"
    rel="noopener noreferrer"
    className="donate-btn"
    style={{
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "center",
      textDecoration: "none",
    }}
  >
    Donate
  </a>
</div>

</div>
          </div>
         

        </div>
      </div>
    </>
  );
}